import { render, staticRenderFns } from "./create.modal.vue?vue&type=template&id=c85fac52&scoped=true&"
import script from "./create.modal.vue?vue&type=script&lang=js&"
export * from "./create.modal.vue?vue&type=script&lang=js&"
import style0 from "./create.modal.vue?vue&type=style&index=0&id=c85fac52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85fac52",
  null
  
)

export default component.exports